import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PageWrap, FadeIn } from '../components/Section';

const openings = [
  { title: 'Junior Civil Engineer', type: 'Full-Time', loc: 'Bhopal, MP', desc: 'Join field operations for site investigations, soil sampling, and geotechnical surveys across Central India.' },
  { title: 'Lab Technician — Materials', type: 'Full-Time', loc: 'Bhopal, MP', desc: 'Conduct concrete, cement, aggregate, and steel testing in our NABL-accredited laboratory.' },
  { title: 'Site Investigation Engineer', type: 'Full-Time', loc: 'Bhopal + Field', desc: 'Lead subsurface exploration including borehole drilling, SPT, and DCPT operations.' },
  { title: 'Lab Training — Internship', type: 'Internship', loc: 'Bhopal, MP', desc: 'Hands-on training for civil engineering students in materials testing and geotechnical procedures.' },
];

export default function Careers() {
  return (
    <PageWrap>
      <section style={{ padding: '160px 0 80px', background: 'var(--warm)' }}>
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <p style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--primary)', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 16 }}>Careers</p>
            <h1 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 700, marginBottom: 20 }}>
              Build Your Engineering<br /><span style={{ color: 'var(--primary-light)' }}>Career With Us</span>
            </h1>
            <p style={{ fontSize: '1.08rem', color: 'var(--text-mid)', maxWidth: 600, lineHeight: 1.7 }}>
              Hicon actively recruits graduating civil engineers through formal campus recruitment drives. Join a team working on national infrastructure projects with NABL-accredited operations.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Academic Alliance */}
      <section style={{ padding: '100px 0', background: 'var(--white)' }}>
        <div className="container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 60, alignItems: 'start' }}>
          <FadeIn>
            <h2 style={{ fontSize: '2.2rem', marginBottom: 16 }}>Academic Partnership</h2>
            <p style={{ fontSize: '0.98rem', color: 'var(--text-mid)', lineHeight: 1.7, marginBottom: 28 }}>
              Hicon participates in formal campus recruitment drives at regional institutions including the Sagar Institute of Science and Technology (SISTec), Bhopal. Graduating civil engineers are integrated into operational roles with mentorship.
            </p>
            <h4 style={{ fontSize: '1rem', marginBottom: 12 }}>Career Tracks</h4>
            {['Field operations and site investigation', 'Laboratory quality management', 'Project consultancy roles', 'Lab training for students'].map(r => (
              <div key={r} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', fontSize: '0.92rem', color: 'var(--text-mid)', borderBottom: '1px solid var(--border)' }}>
                <span style={{ color: 'var(--primary)', fontWeight: 700 }}>✓</span> {r}
              </div>
            ))}
          </FadeIn>
          <FadeIn delay={0.2}>
            <div style={{ background: 'var(--cream)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 40, textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>🎓</div>
              <h3 style={{ fontSize: '1.25rem', marginBottom: 8 }}>SISTec Partnership</h3>
              <p style={{ fontSize: '0.9rem', color: 'var(--text-mid)', marginBottom: 12 }}>Sagar Institute of Science and Technology, Bhopal</p>
              <span style={{ fontSize: '0.82rem', color: 'var(--text-light)' }}>Active campus recruitment pipeline for civil engineering graduates</span>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Openings */}
      <section style={{ padding: '100px 0', background: 'var(--cream)' }}>
        <div className="container">
          <FadeIn>
            <h2 style={{ fontSize: '2.2rem', marginBottom: 12 }}>Current Openings</h2>
            <p style={{ color: 'var(--text-light)', marginBottom: 48 }}>We're growing across field operations, laboratory, and consultancy roles.</p>
          </FadeIn>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {openings.map((job, i) => (
              <FadeIn key={job.title} delay={i * 0.08}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '28px 32px', background: 'white', border: '1px solid var(--border)', borderRadius: 'var(--radius)', gap: 24, flexWrap: 'wrap', transition: 'all 0.3s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--primary-light)'; e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.05)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.boxShadow = 'none'; }}>
                  <div style={{ flex: 1, minWidth: 220 }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: 6 }}>{job.title}</h3>
                    <p style={{ fontSize: '0.88rem', color: 'var(--text-mid)' }}>{job.desc}</p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0, flexWrap: 'wrap' }}>
                    <span style={{ padding: '5px 12px', background: 'rgba(45,74,45,0.06)', borderRadius: 4, fontSize: '0.76rem', fontWeight: 500, color: 'var(--primary)' }}>{job.type}</span>
                    <span style={{ fontSize: '0.83rem', color: 'var(--text-light)' }}>{job.loc}</span>
                    <Link to="/contact" className="btn btn-primary" style={{ padding: '10px 20px', fontSize: '0.83rem' }}>Apply</Link>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Why Join */}
      <section style={{ padding: '100px 0', background: 'var(--white)' }}>
        <div className="container">
          <FadeIn><h2 style={{ fontSize: '2.2rem', textAlign: 'center', marginBottom: 48 }}>Why Join Hicon</h2></FadeIn>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 24 }}>
            {[
              { t: 'National Projects', d: 'Work on infrastructure projects for Indian Railways, NHAI, and CPWD.' },
              { t: 'Research Exposure', d: 'Collaborate with MANIT Bhopal faculty on advanced geotechnical research.' },
              { t: 'Modern Equipment', d: 'Learn on calibrated, professional-grade testing machines.' },
              { t: 'Growth Path', d: 'Clear progression from field engineer to consultancy and quality management.' },
            ].map((item, i) => (
              <FadeIn key={item.t} delay={i * 0.1}>
                <div style={{ padding: 32, background: 'var(--cream)', border: '1px solid var(--border)', borderRadius: 'var(--radius)' }}>
                  <h4 style={{ fontSize: '1.02rem', marginBottom: 8 }}>{item.t}</h4>
                  <p style={{ fontSize: '0.88rem', color: 'var(--text-mid)', lineHeight: 1.6 }}>{item.d}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>
    </PageWrap>
  );
}
